// src/pages/DisciplinaryIncidentActionPage.jsx

import React, { useEffect, useRef, useState } from "react";
import { Button, Table, Space, Tag, Tooltip, Typography, Collapse } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

import {
  fetchDisciplinaryIncidentActionsByParent,
  fetchDisciplinaryIncidentActionsByStudent,
} from "../../store/disciplinaryIncidentActionSlice";

import { fetchProblemActions } from "../../store/problemActionRelationSlice";
import "react-toastify/dist/ReactToastify.css";
import useTokenExpiryCheck from "../../utils/UseTokenExpiryCheck.js";

const { Title, Text } = Typography;
const { Panel } = Collapse;

const DisciplinaryIncidentActionPage = () => {
  const dispatch = useDispatch();

  // Ref to hold the original flags so we only dispatch on *new* checks
  const originalFlagsRef = useRef({
    requiresParentalMeeting: false,
    requiresCounseling: false,
    requiresHearing: false,
  });

  const {
    items: actions,
    status,
  } = useSelector((state) => state.disciplinaryIncidentAction);
  const [isParent, setIsParent] = useState(false);
  const [isStudent, setIsStudent] = useState(false);
  const [userId, setUserId] = useState("");

  useTokenExpiryCheck();
   useEffect(() => {
     const userInfoString = localStorage.getItem("userInfo");
     const userInfo = userInfoString ? JSON.parse(userInfoString) : {}; // Parse if
     const roles = userInfo?.roles || [];
      console.log("roles", roles);
     console.log("userInfo", userInfo);
     const userId = userInfo?.userId || [];
     console.log("userId", userId);
     if (roles.includes("Parent")) {
       setIsParent(true);
       setUserId(userId);
     } else if (roles.includes("Student")) {
       setIsStudent(true);
       setUserId(userId);
     } else {
       setIsStudent(false);
       setIsParent(false);
       setUserId(null);
     }
    }, [dispatch]);
 
  useEffect(() => {
    dispatch(fetchProblemActions());

    if (isParent) dispatch(fetchDisciplinaryIncidentActionsByParent(userId));
    else if (isStudent)
      dispatch(fetchDisciplinaryIncidentActionsByStudent(userId));
  }, [isParent, isStudent, userId, dispatch]);


  const columns = [
    {
      title: "Student",
      dataIndex: "studentName",
      key: "studentName",
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Incident",
      key: "incident",
      render: (_, rec) => (
        <Tooltip title={rec.incidentDescription || "—"}>
          <Text>{rec.incidentDescription || "Unknown"}</Text>
        </Tooltip>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, rec) => (
        <Tooltip title={rec.actionName || "—"}>
          <Text>{rec.actionName || "Unknown"}</Text>
        </Tooltip>
      ),
    },
    {
      title: "Status",
      key: "status",
      render: (_, rec) => {
        const st =
          rec.hearingStatus === 2
            ? "Completed"
            : rec.counclingStatus === 2
            ? "Active"
            : "Pending";
        const color =
          st === "Pending" ? "orange" : st === "Completed" ? "green" : "blue";
        return <Tag color={color}>{st}</Tag>;
      },
    },
  ];

  return (
    <div style={{ padding: "24px" }}>
      <Title level={2} style={{ marginBottom: "16px" }}>
        Disciplinary Incident Actions
      </Title>
      <Text type="secondary" style={{ display: "block", marginBottom: 16 }}>
        {isStudent
          ? "Review your disciplinary issues, actions and action status"
          : isParent
          ? "Review your child's disciplinary issues, actions and action status"
          : "Review disciplinary actions for the assigned to student incidents."}
      </Text>

      <Table
        loading={status === "loading"}
dataSource={actions.filter(
  (rec) =>
    rec.hearingStatus !== 2 && rec.counclingStatus !== 2
)}
        columns={columns}
        rowKey="incidentActionID"
        expandable={{
          expandedRowRender: (rec) => {
            const pm = rec.parentalHearingStatus > 0;
            const co = rec.counclingStatus > 0;
            const he = rec.hearingStatus > 0;
            return (
              <Collapse defaultActiveKey={["1"]}>
                <Panel header="Incident Details" key="1">
                  <Text strong>Incident Description:</Text>{" "}
                  {rec.incidentDescription || "N/A"}
                  <br />
                  <Text strong>Action Name:</Text> {rec.actionName || "N/A"}
                  <br />
                  <Text strong>Created Date:</Text> {rec.createdDate || "N/A"}
                  <br />
                  <Text strong>Urgent:</Text> {rec.status === 2 ? "Yes" : "No"}
                  <br />
                  <Text strong>Parental Meeting Done:</Text> {pm ? "Yes" : "No"}
                  <br />
                  <Text strong>Counseling Done:</Text> {co ? "Yes" : "No"}
                  <br />
                  <Text strong>Hearing Done:</Text> {he ? "Yes" : "No"}
                </Panel>
              </Collapse>
            );
          },
        }}
        scroll={{ x: true }}
      />

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default DisciplinaryIncidentActionPage;
